import { Injectable } from '@angular/core';

import { first, Observable } from 'rxjs';

import { TradingPartner } from '../../models';
import { ApiService } from '../../services';

const ENDPOINT = 'v1/partners';

@Injectable({ providedIn: 'root' })
export class TradingPartnersApiService {
  constructor(private api: ApiService) {
  }

  list(includeSelf = false): Observable<TradingPartner[]> {
    return this.api.get<TradingPartner[]>(ENDPOINT, { params: { includeSelf } }).pipe(first());
  }

  listMessageTypes(): Observable<string[]> {
    return this.api.get<string[]>(`${ENDPOINT}/types`).pipe(first());
  }

  listBusinessruleTypes(): Observable<string[]> {
    return this.api.get<string[]>(`${ENDPOINT}/businessrules`).pipe(first());
  }
}
